import { NgSelectModule } from '@ng-select/ng-select';
import { HttpMonitor } from './../../../../libs/core/src/lib/utils/http.monitor';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from 'libs/shared/src/lib/shared.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptorService } from 'libs/core/src/lib/services/auth-interceptor.service';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';
import { PrivilegeService } from './services/privilege.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    ToastrModule.forRoot(), 
    NgxGalleryModule,
    HttpClientModule,
    NgSelectModule,
    BrowserAnimationsModule, // required animations module
    NgbModule],
  providers: [HttpMonitor,{
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptorService,
    multi: true
  },PrivilegeService],
  bootstrap: [AppComponent],
})
export class AppModule {}
